import { Form } from 'react-router-dom'
import styled from 'styled-components'

import { BodyS } from '@/components/Text.tsx'

const FormStyled = styled(Form)<{
  align?: 'top' | 'center'
}>`
  display: flex;
  flex-flow: column;
  flex: 1;
  justify-content: ${({ align }) =>
    align === 'center' ? 'center' : 'flex-start'};
  text-align: left;
  overflow-y: auto;
`

const FormElement = styled.div`
  & + & {
    margin-top: 24px;
  }
`

const FormSubmit = styled.div`
  flex: 0;
  background-color: ${({ theme }) => theme.colors.common.white};
  width: 100%;
  display: flex;
  flex-flow: column;
  padding-top: 32px;
  gap: 16px;
`

const FormElementError = styled(BodyS)`
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.common.alert};
`

const FormError = styled(BodyS)`
  color: ${({ theme }) => theme.colors.common.alert};
`

export { FormElement, FormElementError, FormError, FormStyled, FormSubmit }
